// import gsap libraries. Comment these out before publish
// as we want them purely for syntax here. We will add the
// GSAP librairies via CDN in the website.
// import { gsap } from 'gsap';
// import { TextPlugin } from 'gsap/TextPlugin';

console.log('GSAP script has loaded');

const tl = gsap.timeline({});

function init() {
  gsap.set('.home-hero_intro', { autoAlpha: 1 });
  // console.log('Init has run');

  tl.from('.loading-letter', {
    opacity: 0,
    stagger: 0.05,
    ease: 'back.inOut(1.7)',
    y: -10,
    x: -10,
  })
    .from(
      '.home-hero-copy_wrap',
      {
        opacity: 0,
        duration: 1.5,
        ease: 'power1.in',
      },
      '-=1'
    );
}
window.addEventListener('load', function () {
  // console.log('Page loaded!');
  init();
});
